import useFirebase from './useFirebase';

export default useFirebase;
